// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";
const { setupFWPCategories } = require('./fwp-search.js');

const $ = jQuery;

var cardImage = $('<img class="card-group">').attr('src', '/app/uploads/2023/11/payment-card-update.svg');
$('.single_add_to_cart_button').after(cardImage);

var $searchHolder = $('.search-holder-new');
var $facetSearch = $('body.tax-product_cat.term-online-legal-docs .facetwp-facet-search').hide();

$searchHolder.click(function (event) {
  event.stopPropagation(); // Prevent click on $searchHolder from triggering document click

  if ($facetSearch.is(':visible')) {
    $facetSearch.hide();
  } else {
    $facetSearch.show();
  }
  if ($searchHolder.is(':visible')) {
    $searchHolder.hide();
  } else {
    $searchHolder.show();
  }
});

$facetSearch.click(function (event) {
  event.stopPropagation(); // Prevent click on $facetSearch from hiding it
});

$(document).click(function () {
  $facetSearch.hide();
  $searchHolder.show();
});


$(() => {
  if ($.cookie('form_submitted') === 'true') {
    $('.top-banner').hide();
  }

  // Attach a click event handler to the close button
  $(".close").click(function () {
    // Find the closest ancestor element with class 'top-banner' and hide it
    $(this).closest(".top-banner").hide();
  });




  var h1Element = $(".product_title.entry-title");
  var divElement = $(".doc-info");
  divElement.insertAfter(h1Element);


  $('ul.products li.product').each(function () {
    var priceEle = $(this).find("span.price");
    var addToCartEle = $(this).find('.add-to-cart-wrap .quantity');
    priceEle.insertBefore(addToCartEle);
  })



  // Move p.woocommerce-result-count
  $('p.woocommerce-result-count').appendTo('.right-holder-ele');

  // Move form.woocommerce-ordering
  $('form.woocommerce-ordering').appendTo('.right-holder-ele');

  var breadcrumb = $('body.single-product .woocommerce-breadcrumb');
  var h1 = $('.product_title.entry-title');
  breadcrumb.insertBefore(h1);

  // Move reviews to tab panel
  var reviewSourceDiv = $("#reviews.woocommerce-Reviews");
  var reviewsDiv = $("#review");
  reviewSourceDiv.appendTo(reviewsDiv);

  //hide review nav is no review
  if ($('#reviews #comments').length === 0) {
    $('.nav-item.review').hide();
  }

  //make faq the first active tab if no available pack
  if ($('.product-content-wrap #myTab li:first').hasClass('faqs')) {
    $('.tab-pane#faqs').addClass('show active');
    $('#myTab li.faqs:first a').addClass('active');
  }

  $('form.af-form').each(function (this: HTMLFormElement) {
    new AdvancedForm(this);
  });

  document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $('.gallery a.thumbnail').fluidbox();
  $('.gallery a.thumbnail img').each(function (this: HTMLImageElement) {
    if (this.src !== this.getAttribute('src')) {
      $(this).replaceWith($(this.outerHTML));
    }
  });

  // flyout menu
  $('.navbar-collapse.width').on('show.bs.collapse hide.bs.collapse', function (e) {
    $('body').toggleClass('menu-visible');
  });

  $(document).ready(setupFWPCategories())

  // On Page mount, if affiliates page
  // Move disclaimer div into the same row as gravity forms submit button. 
  if (window.location.pathname.includes("/become-an-affiliate")) {
    const disclaimerDiv = $("#form_disclaimer");
    var gform_footer = $("#affiliate_form .gform_footer");
    gform_footer.prepend(disclaimerDiv);
  }
});
